import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { FormRequestDocumentValues } from 'Interfaces/Document';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: FormRequestDocumentValues) =>
    $actions.document.createDocumentFromFormRequest(dispatch, values),
  );
};
